import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { RideTrackerMapService } from '../ride-tracker-map/ride-tracker-map.service';

@Component({
  selector: 'app-dist-time-details',
  templateUrl: './dist-time-details.component.html',
  styleUrls: ['./dist-time-details.component.css']
})
export class DistTimeDetailsComponent implements OnInit, OnChanges {

  constructor(private rideTrackerMapService: RideTrackerMapService) { }
  @Input() distTimeDetails: any;
  @Input() poolInfo: any;
  public info: any;
  private tripMatchData: any;

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    // Handle poolInfo changes - fetch trip match data for HOPR orders
    if (changes && changes.poolInfo && changes.poolInfo.currentValue && changes.poolInfo.currentValue.type === 'MPMD_CORPORATE_POOL' && changes.poolInfo.currentValue.tripMatchId) {
      this.fetchTripMatchData();
      // If we just triggered a fetch for HOPR order, skip distTimeDetails handling below to avoid race condition
      if (changes.distTimeDetails && changes.distTimeDetails.currentValue) {
        return;
      }
    }

    // Handle distTimeDetails changes - construct appropriate card
    if (changes.distTimeDetails && changes.distTimeDetails.currentValue) {
      if (!changes.distTimeDetails.currentValue.dataFetched) {
        this.emptyCard();
      } else {
        // Check if this is a HOPR order with trip match data - use trip match card, otherwise use regular card
        if (this.poolInfo && this.poolInfo.type === 'MPMD_CORPORATE_POOL' && this.tripMatchData) {
          this.constructTripMatchCard();
        } else {
          this.constructCard();
        }
      }
     } else if (!changes.distTimeDetails) {
      // If only poolInfo changed and we don't have distTimeDetails, do nothing (wait for distTimeDetails)
      // This prevents showing empty card when poolInfo changes but distTimeDetails hasn't loaded yet
      return;
    }
  }

  // Fetch the trip match data for HOPR orders
  private fetchTripMatchData() {
    if (this.poolInfo.tripMatchId) {
      this.rideTrackerMapService.getPoolTripMatchById(this.poolInfo.tripMatchId).subscribe(result => {
        if (result && result['data']) {
          this.tripMatchData = result['data'];
        } else if (result && result['id']) {
          // Direct trip match object response
          this.tripMatchData = result;
        }
        this.constructTripMatchCard();
      }, error => {
        // Even if API fails, construct the regular card
        this.tripMatchData = null;
        this.constructCard();
      });
    } else {
      this.constructCard();
    }
  }

  emptyCard() {
    this.info = {
      tableHeader: 'Distance & Time',
      dataFetched: false,
      data: [],
      emptyMessage: 'No data found'
    };
  }

  constructCard() {
    // Original method for regular orders
    let data: {[key: string]: any} = {};
    let headers = {};
    if (this.distTimeDetails.acceptToCancel) {
      headers = {acceptToCancel: 'Accept to cancel'}
      data = { acceptToCancel: { data: this.distTimeDetails.acceptToCancel ? this.distTimeDetails.acceptToCancel + ' kms' : ''}};
    }
    data = { ...data,
      acceptToPickup: {data: this.distTimeDetails.acceptToPickup ? this.distTimeDetails.acceptToPickup + ' kms' : ''},
      estimatedDistance: {data: this.distTimeDetails.estimatedDistance ? this.distTimeDetails.estimatedDistance + ' kms' : ''},
      finalEstimatedDistance: {data: this.distTimeDetails.finalEstimatedDistance ? this.distTimeDetails.finalEstimatedDistance + ' kms' : this.distTimeDetails.finalDistance ? this.distTimeDetails.finalDistance + ' kms' : ''},
      hfDistance: {data: this.distTimeDetails.hfDistance ? this.distTimeDetails.hfDistance + ' kms' : ''},
      estimatedRideTime: {data: this.distTimeDetails.estimatedRideTime ? this.distTimeDetails.estimatedRideTime + ' mins' : ''},
      finalRideTime: {data: this.distTimeDetails.finalRideTime ? this.distTimeDetails.finalRideTime + ' mins' : ''},
      pickupCluster: {information: this.distTimeDetails.pickupCluster && this.distTimeDetails.pickupCluster.radius ? this.distTimeDetails.pickupCluster.radius + ' kms' : null,
                data: this.distTimeDetails.pickupCluster && this.distTimeDetails.pickupCluster.name ? this.distTimeDetails.pickupCluster.name : ''},
      dropCluster: {information: this.distTimeDetails.dropCluster && this.distTimeDetails.dropCluster.radius ? this.distTimeDetails.dropCluster.radius + ' kms' : null,
                data: this.distTimeDetails.dropCluster && this.distTimeDetails.dropCluster.name ? this.distTimeDetails.dropCluster.name : ''},
      odrdDistance: {data: this.distTimeDetails.odrdDistance ? this.distTimeDetails.odrdDistance + ' kms' : ''},
      distanceSuggested: {data: this.distTimeDetails.distanceSuggested ? this.distTimeDetails.distanceSuggested : ''},
    }

    let allHeaders: {[key: string]: string} = {...headers, acceptToPickup: 'Accept to pickup', estimatedDistance: 'Initial Estimated distance', finalEstimatedDistance: 'Final Estimated distance', hfDistance: 'Hf distance', estimatedRideTime: 'Initial Estimated ride time',
      finalRideTime: 'Actual ride time', odrdDistance: 'ODRD(Actual) Distance', distanceSuggested: 'Distance Suggested', pickupCluster: 'Pickup cluster', dropCluster: 'Drop cluster'};

    this.info = {
      tableHeader: 'Distance & Time',
      expandTable: false,
      headers: allHeaders,
      headerClass: 'color-card-header',
      dataFetched: true,
      data: [data]
    };
  }

  // Construct the card for HOPR orders
  constructTripMatchCard() {
    // Method for HOPR orders - shows only pool-specific columns
    if (!this.tripMatchData || !this.tripMatchData.distancesInMeters || !this.tripMatchData.distancesInMeters.guest) {
      // Fallback to regular card if no trip match data
      this.constructCard();
      return;
    }

    const guestDistances = this.tripMatchData.distancesInMeters.guest;
    let data: {[key: string]: any} = {
      guestFirstMile: {data: guestDistances.firstMile ? (guestDistances.firstMile / 1000).toFixed(2) + ' kms' : '0.00 kms'},
      guestLastMile: {data: guestDistances.lastMile ? (guestDistances.lastMile / 1000).toFixed(2) + ' kms' : '0.00 kms'},
      overlapDistance: {data: guestDistances.startToEnd ? (guestDistances.startToEnd / 1000).toFixed(2) + ' kms' : '0.00 kms'}
    }

    // Add time column if available
    if (this.tripMatchData.pricing && this.tripMatchData.pricing.timeInMins) {
      data = { ...data,
        startToEndTimeInMins: {data: this.tripMatchData.pricing.timeInMins + ' mins'}
      }
    }

    let allHeaders: {[key: string]: string} = {
      guestFirstMile: 'Guest Start to HopIn (FM)',
      guestLastMile: 'HopOut to Guest Drop (LM)',
      overlapDistance: 'Overlap Distance'
    }

    if (this.tripMatchData.pricing && this.tripMatchData.pricing.timeInMins) {
      allHeaders = { ...allHeaders,
        startToEndTimeInMins: 'Start to End Time'
      }
    }

    this.info = {
      tableHeader: 'Distance & Time',
      expandTable: false,
      headers: allHeaders,
      headerClass: 'color-card-header',
      dataFetched: true,
      data: [data]
    };
  }
}